function initEmptyCollectionSlider(slider, space = 15) {
  new Swiper(slider, {
    slidesPerView: 2.2,
    spaceBetween: space,
    autoHeight: false,
    navigation: {
      nextEl: slider.querySelector('.swiper-button-next'),
      prevEl: slider.querySelector('.swiper-button-prev'),
    },
  });
}


class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.emptySlider = this.querySelector('.empty_cart_collection_inner');
    const debouncedOnChange = debounce(
      this.onChange.bind(this),
      ON_CHANGE_DEBOUNCE_TIMER
    );

    this.addEventListener("change", debouncedOnChange);

    const spacing = this.dataset.spacing;

    if(this.emptySlider) {
      initEmptyCollectionSlider(this.emptySlider);
    }

    window.updateCartDrawer = this.updateCartDrawer.bind(this);
  }

  connectedCallback() {
    this.initCartNoteToggle();

    this.totalPrice = this.parsePrice(this.dataset.total);
    this.threshold = this.parsePrice(this.dataset.threshold);
    
    const shippingBar = this.querySelector('.cc_free_shipping_bar_wrapper');
    if(shippingBar && this.threshold > 0) {
      this.shippingBarUpdate(this.totalPrice);
    }
  }

  parsePrice(priceString) {
    if (!priceString) return 0;
    
    const numericString = priceString.toString().replace(/[^\d.]/g, '');
    const parsed = parseFloat(numericString);
    
    return isNaN(parsed) ? 0 : parsed;
  }

  shippingBarUpdate(totalPrice = 0) {
    const currency = Shopify.currency?.active || '{{ cart.currency.iso_code }}';

    const rate = Shopify.currency?.rate || 1;
    const final = Math.round(this.threshold * rate * 100) / 100;
    const convertedTotal = totalPrice

    const remaining = (final * 100) - convertedTotal;
    const percentage = Math.min(Math.round((convertedTotal / (final * 100)) * 100), 100);


    function formatMoney(cents, currency = 'USD') {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency,
        minimumFractionDigits: 2
      }).format(cents / 100);
    }


    const bar = this.querySelector('.cc_shipping_progress_bar_inner')
    if(bar) {
      bar.style.setProperty('--width', `${percentage}%`)
    }

    const message = this.querySelector('.cc_shipping_bar_text p');
    if(!message) return;
    if(remaining > 0) {
      message.textContent = `Spend ${formatMoney(remaining, currency)} more to reach FREE SHIPPING.`
    } else {
      message.textContent = 'You are eligible for FREE SHIPPING!!'
    }

  }

  formatMoney(cents, currency = 'USD') {
    // Convert cents to the actual currency amount
    const amount = cents / 100;
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency,
      minimumFractionDigits: 2
    }).format(amount);
  }

  initCartNoteToggle() {
    this.cartNoteFooter = this.querySelector('.cart_drawer_note_wrapper');

    if (this.cartNoteFooter) {
      this.btn = this.querySelector('.cart_drawer_cart_note_header button.cd_cn_btn');
      this.note = this.querySelector('main-cart-note');

      if (!this.btn || !this.note) return;

      this.btn.addEventListener('click', () => {
        this.btn.classList.toggle('rot');
        this.note.classList.toggle('show');

        const textarea = this.note.querySelector('textarea');
        if (!textarea) return;
        textarea.setAttribute('tabindex', this.note.classList.contains('show') ? '0' : '-1');
      });
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  validateQuantity(event) {
    const input = event.target;
    const inputValue = parseInt(input.value);
    const index = input.dataset.line;

    const wrapper = input.closest(
      ".cart_content_info_left"
    )?.nextElementSibling;
    const loader = wrapper?.querySelector(".loader");
    const priceElement = wrapper?.querySelector(
      ".cart_content_final_price_wrapper"
    );

    loader?.classList.remove("hidden");
    priceElement?.querySelector("span").classList.add("hidden");

    const message = "";

    if (message) {
      this.setValidity(event, index, message);
    } else {
      input.setCustomValidity("");
      input.reportValidity();
      this.updateQty(index, inputValue, loader, priceElement);
    }
  }

  async updateQty(line, quantity, loader = null, priceElement = null) {
    const formData = { line, quantity };

    try {
      const response = await fetch(
        `${window.Shopify.routes.root}cart/change.js`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        }
      );

      const responseText = await response.text();

      if (!response.ok) {
        const errorData = JSON.parse(responseText);
        const cartData = await fetch("/cart.js").then((res) => res.json());
        this.updateCartDrawer(cartData, cartData.item_count, line, errorData.description);
        return;
      }

      const parsedData = JSON.parse(responseText);
      this.updateCartDrawer(parsedData, parsedData.item_count);
    } catch (error) {
      console.error("Qty update failed:", error);
    }
  }

  async updateCartDrawer(cart = null, count, line = null, message = null) {
    try {
      const response = await fetch(
        `${window.Shopify.routes.root}?section_id=main-cart-drawer`
      );
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const newSection = doc.querySelector("cart-drawer");

      const currentSection = document.querySelector("cart-drawer");
      if (newSection && currentSection) {
        currentSection.innerHTML = newSection.innerHTML;

        const newEmptySlider = currentSection.querySelector('.empty_cart_collection_inner');
        const spacingAttr = currentSection.dataset.spacing;
        const spacing = 15;

         if (newEmptySlider) {
           initEmptyCollectionSlider(newEmptySlider, spacing);
         }        

        currentSection.initCartNoteToggle();

        // Parse the updated values from the new section
        currentSection.totalPrice = currentSection.parsePrice(currentSection.dataset.total);
        currentSection.threshold = currentSection.parsePrice(currentSection.dataset.threshold);
        
        // Use cart data if available, otherwise use dataset values
        const totalToUse = cart?.total_price || currentSection.totalPrice;
        currentSection.shippingBarUpdate(totalToUse);

        if (line && message) {
          const errorWrapper = document
            .querySelector(`[data-index="${line}"]`)
            ?.closest("qty-input")?.nextElementSibling;
          if (errorWrapper) {
            errorWrapper.innerHTML = `<span class="cart_error">${message}</span>`;
          }
        }
      }     
      this.updateCartBubble(count);
    } catch (err) {
      console.error("Error updating cart section:", err);
    }
  }

  updateCartBubble(count) {
    const bubbles = document.querySelectorAll("#cart-icon-bubble .cart-count-text");
    const bubbleHiddens = document.querySelectorAll(
      "#cart-icon-bubble .visually-hidden"
    );

    bubbles.forEach((bubble) => {
      if(bubble.classList.contains('hide_on_desktop')) {
        bubble.querySelector('span.cc_text').textContent = count;        
      } else {
        bubble.querySelector('span.cc_text').textContent = `(${count})`;        
      }
    });

    bubbleHiddens.forEach((bubbleHidden) => {
      bubbleHidden.textContent = `${count} items`;
    });
  }
}

customElements.define("cart-drawer", CartDrawer);